/**
 * CareStart city pages: /carestart/[cityname]
 * England entries are filed under United Kingdom in the clipart skyline 7 catalog.
 * Extra keys are individual cities outside those countries.
 */

import skyline7 from "../../cities1/skyline7.json";

const CITY_COUNTRIES = new Set(["Kenya", "United Kingdom"]);
const EXTRA_CITY_KEYS = new Set(["United States|Chicago"]);

/**
 * @param {string} cityName
 * @returns {string}
 */
export function careStartCitySlug(cityName) {
  return String(cityName || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function buildCityPages() {
  /** @type {{ slug: string, cityName: string, country: string, path: string, src: string }[]} */
  const pages = [];
  const seen = new Set();

  for (const [key, fileSlug] of Object.entries(skyline7)) {
    const splitAt = key.indexOf("|");
    if (splitAt < 0) continue;
    const country = key.slice(0, splitAt);
    const cityName = key.slice(splitAt + 1);
    if ((!CITY_COUNTRIES.has(country) && !EXTRA_CITY_KEYS.has(key)) || !cityName || !fileSlug) continue;

    const slug = careStartCitySlug(cityName);
    if (!slug || seen.has(slug)) continue;
    seen.add(slug);
    pages.push({
      slug,
      cityName,
      country,
      path: `/carestart/${slug}`,
      src: `/cities1/clipart7/${fileSlug}.svg`,
    });
  }

  pages.sort((a, b) => a.cityName.localeCompare(b.cityName));
  return pages;
}

export const CARESTART_CITY_PAGES = buildCityPages();

const CITY_BY_SLUG = new Map(CARESTART_CITY_PAGES.map((city) => [city.slug, city]));

/**
 * @param {string} slug
 * @returns {{ slug: string, cityName: string, country: string, path: string, src: string }|null}
 */
export function getCareStartCityPage(slug) {
  return CITY_BY_SLUG.get(String(slug || "")) || null;
}

/**
 * @param {string} slug
 * @returns {boolean}
 */
export function isCareStartCitySlug(slug) {
  return CITY_BY_SLUG.has(String(slug || ""));
}
